import { type RefObject, useEffect, useState } from "react";

/** Pause both CSS and canvas work for background tabs and hidden keep-alive pages. */
export function useBobMotion(ref: RefObject<HTMLSpanElement | null>, requested: boolean) {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element || !requested) {
      setAvailable(false);
      return;
    }
    const preference = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    let inView = typeof IntersectionObserver === "undefined";
    const sync = () => setAvailable(inView && !document.hidden && !preference?.matches);
    const observer =
      typeof IntersectionObserver === "undefined"
        ? null
        : new IntersectionObserver(
            (entries) => {
              inView = entries.some((entry) => entry.isIntersecting);
              sync();
            },
            { threshold: 0 },
          );
    observer?.observe(element);
    preference?.addEventListener("change", sync);
    document.addEventListener("visibilitychange", sync);
    sync();
    return () => {
      observer?.disconnect();
      preference?.removeEventListener("change", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, [ref, requested]);
  return requested && available;
}
